import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

import DataTableList from '../../components/DataTable/DataTableList'

const DashboardProofSubmission = () => {
    const stats = useSelector((state) => state.dashboard.proofSubmissions);
    const [columnWidths, setColumnWidths] = useState([]);

    useEffect(() => {
        if (stats?.length > 0) {
            // calculateColumnWidths().then(() => {
            //     setTimeout(() => {
            //         setIsLoadingData(false);
            //     }, 1000);
            // });
            calculateColumnWidths()
        }
    }, [stats]);

    const calculateColumnWidths = () => {
        return new Promise((resolve) => {
            const tempWidths = stats?.reduce((acc, row) => {
                Object.keys(row).forEach((key) => {
                    const dataValue = row[key].toString();
                    const title = row[key];

                    let maxContentLength = 0;

                    maxContentLength = Math.max(dataValue.length, title.length);
                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});
            if (tempWidths !== undefined) {
                const widthMap = Object.keys(tempWidths).reduce((acc, key) => {

                    acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    return acc;
                }, {});

                setColumnWidths(widthMap); // Set the calculated column widths
            }
            resolve(); // Resolve the promise once widths are set
        });

    };
    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '24px',
                color: '#666666'
            },
        },
    };
    const columns = [
        {
            name: 'Name',
            selector: (row) => row?.name,
            width: `${parseInt(columnWidths['name']) - 10}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontWeight: 500, fontSize: '14px', lineHeight: '24px', color: '#05171A' },
        },
        {
            name: 'Email',
            selector: (row) => row?.email,
            width: columnWidths['email'] && (parseInt(columnWidths['email']) + 30 > 300) ? '300px' : `${parseInt(columnWidths['email']) - 20}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px", fontWeight: 500, fontSize: '14px', lineHeight: '24px', color: '#05171A' },
        },
        {
            name: 'Proof #1',
            cell: (row) => (
                <span className="table-action-btn view-btn">View</span>
            ),
            width: '100px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px" },
        },
        {
            name: 'Proof #2',
            cell: (row) => (
                <span className="table-action-btn view-btn">View</span>
            ),
            width: '100px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px" },
        },
        {
            name: 'Actions',
            cell: (row) => (
                <div className="actions-container">
                    <span className="table-action-btn approve-btn">Approve</span>
                    <span className="table-action-btn warning-btn">Unable to verify</span>
                    <span className="table-action-btn deny-btn">Deny</span>
                </div>
            ),
            width: '290px',
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "10px", paddingBottom: "10px" },
        }
    ]
    return (
        <div className='table-pagination-wrapper proof-submission-list'>
            <h3 className="heading">Proof submissions</h3>
            <div className={`pagesTable dataTable-list`}>
                <DataTableList
                    data={stats}
                    columns={columns}
                    customStyles={customStyles}
                    pagination={false}
                />
            </div>
        </div>
    )
}

export default DashboardProofSubmission
